import { useEffect, useMemo } from 'react';

import { InfiniteData, useInfiniteQuery } from '@tanstack/react-query';
import { IGroundTruthListResponse } from '../../api/types';
import { IGroundTruth } from '../../types/my-types';
import useGlynt from './useGlynt';

function getNextPageParam(next: string) {
  // Get offset from api response
  const rgx = /offset/g;
  const index = next.search(rgx);
  return Number(next.substring(index + 7, index + 10));
}

const NO_GROUND_TRUTHS: IGroundTruth[] = [];

function mergeResults(data: InfiniteData<IGroundTruthListResponse> | undefined) {
  if (!data) return NO_GROUND_TRUTHS;

  let results: IGroundTruth[] = [];

  data.pages.map((page) => {
    results = results.concat(page.results);
    return true;
  });

  return results;
}

export default function useGroundTruths(docId: string, trainingSet: string) {
  const glynt = useGlynt();
  // console.log({ docId });

  const { data, isError, isLoading, isFetching, fetchNextPage, hasNextPage, refetch } =
    useInfiniteQuery({
      queryKey: ['groundTruths', docId, trainingSet],
      queryFn: async ({ pageParam }) =>
        (await glynt).groundTruths.list({
          advanced: true,
          document: docId,
          training_set: trainingSet,
          limit: 100,
          offset: pageParam,
        }),
      initialPageParam: 0,
      getNextPageParam: (lastPage) => {
        if (lastPage.next) return getNextPageParam(lastPage.next);
      },
      refetchOnWindowFocus: false,
    });

  useEffect(() => {
    refetch();
  }, [docId, refetch]);

  useEffect(() => {
    if (hasNextPage) {
      fetchNextPage();
    }
  }, [data, hasNextPage, fetchNextPage]);

  const groundTruths = useMemo(() => mergeResults(data), [data]);

  if (isLoading || isError) {
    return NO_GROUND_TRUTHS;
  }

  return groundTruths;
}
